import * as yup from "yup";

const validationSchema = yup.object({
  name: yup.string().required(),
  url: yup.string().nullable(),
  notes: yup.string().nullable(),
  category: yup.string().required(),
  attachments: yup.array().of(yup.string().nullable()),
  customers: yup.array().min(1, "At least one customer is required").of(
    yup.object({
      name: yup.string().required("Customer name is required"),
      isCurrentlyBuying: yup.boolean(),
      notes: yup.string().nullable(),
      annualProjectionInDollars: yup.number().min(0).nullable(),
    }),
  ),
});

export default validationSchema;
